export default {
    topbar: { delivery: "משלוח מקומי מהיר • HE / EN / TH", support: "תמיכה", orders: "הזמנות", about: "אודות" },
    header: {
        searchPlaceholder: "חיפוש מוצרים, מותגים וקטגוריות…", language: "שפה", notifications: "התראות",
        hello: "שלום", account: "חשבון", signIn: "התחברות", signUp: "הרשמה", shoppingCart: "עגלת קניות", myOrders: "הזמנות שלי", settings: "הגדרות", signOut: "התנתקות", theme: "ערכת נושא", dark: "כהה", light: "בהירה", darkTheme: "ערכת נושא כהה", lightTheme: "ערכת נושא בהירה", cartItems: "{{count}} פריטים"
    },
    filters: {
        discover: "גילוי", realProducts: "מוצרי פיטנגו", newArrivals: "חדשים", reorder: "מוכנים להזמנה חוזרת",
        thaiProducts: "מוצרים מתאילנד", drinks: "משקאות", snacks: "חטיפים", offers: "מבצעים מיוחדים"
    },
    mobileNav: { home: "בית", categories: "קטגוריות", search: "חיפוש", menu: "תפריט", cart: "עגלה" },
    sidebar: {
        title: "קטגוריות", subtitle: "הכול במרחק לחיצה", discover: "גילוי", homePage: "דף הבית", beverages: "משקאות",
        instantFood: "מזון מהיר", riceNoodles: "אורז ואטריות", snacks: "חטיפים", household: "לבית",
        personalCare: "טיפוח אישי", deals: "מבצעים", promoTitle: "קנייה חוזרת מהירה",
        promoText: "החזירו מוצרים קבועים לעגלה במהירות וקצרו את הדרך בקנייה הבאה.",
        subcategories: {
            coffeeTea: "קפה ותה", milkPowder: "אבקת חלב", softDrinks: "משקאות קלים",
            noodles: "אטריות", soups: "מרקים", readyMeals: "ארוחות מוכנות", rice: "אורז", saucesSeasoning: "רטבים ותבלינים",
            cookies: "עוגיות", chips: "צ'יפס וחטיפים", sweets: "ממתקים", cleaning: "ניקיון", laundry: "כביסה", paperGoods: "מוצרי נייר",
            soapShampoo: "סבון ושמפו", dentalCare: "טיפוח הפה", dailyEssentials: "מוצרי יום-יום"
        }
    }
} as const;
